// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import axios from "axios";
import { updateAxiosConfig } from "./Services/AxiosInstance";
import { Amplify } from "aws-amplify";
import { ConfigProvider } from "./configContext";

const loadConfig = async () => {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  const origin = window.location.origin;
  const res = await axios.get(`${origin}/static/config.json`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  const config = res.data;

  console.log("Config loaded:", config);

  // Configure Amplify using the AUTH section of the config
  if (config.AUTH) {
    Amplify.configure(config.AUTH);
  } else {
    console.error("AUTH configuration missing in config");
  }

  // Update Axios instance with the config (so services get the BASE_URL, etc.)
  updateAxiosConfig(config);

  return config;
};

const rootElement = document.getElementById("root");

loadConfig()
  .then((config) => {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <ConfigProvider config={config}>
          <Router>
            <App />
          </Router>
        </ConfigProvider>
      </React.StrictMode>
    );
    reportWebVitals();
  })
  .catch((error) => {
    console.error("Error loading configuration:", error);
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <div>Error loading configuration. Please try again later.</div>
      </React.StrictMode>
    );
  });
